import { IRouter } from "@aurelia/router";
import { bindable, inject } from "aurelia";

@inject(IRouter)
export class NextStepsComponent {
  @bindable stepsToShow: string[] = ['brandkit', 'site', 'posts', 'blog', 'products'];

  constructor(private router: IRouter) {
  }

}